export default {
    init() {
      jQuery('.woocommerce-form-register').on('submit', function() {
        window.setFullPageLoader(true, 'Please Wait', 'Processing your registration...');
      });
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/woocommerceAccount.js